export default "__VITE_ASSET__DGVYs_lx__"